/**
 * Что площадка сообщает о себе — точка внедрения платформы
 * (docs/MOBILE.md, шаг 2).
 *
 * config.ts не читает window.__env, import.meta.env и window.location сам:
 * в React Native нет ни того, ни другого, а свои источники (константы Expo,
 * EXPO_PUBLIC_*) подставятся здесь — прикладной код при этом не меняется.
 */
type Env = Partial<Record<string, string>>

export interface PlatformEnv {
  /**
   * Runtime-значение. На вебе — window.__env, который генерирует
   * nginx-энтрипоинт образа: благодаря ему один и тот же образ переезжает
   * между dev/qa/prod без пересборки.
   */
  runtime(key: string): string | undefined
  /** Build-time значение. На вебе — import.meta.env у vite. */
  buildTime(key: string): string | undefined
  /** Хост, куда открыта страница — дефолтный адрес WebSocket. */
  hostname(): string
}

declare global {
  interface Window {
    __env?: Env
  }
}

/** Веб-реализация — единственное место модуля, знающее про window. */
export const platformEnv: PlatformEnv = {
  runtime: (key) => window.__env?.[key],
  buildTime: (key) => (import.meta.env as Env)[key],
  hostname: () => window.location.hostname,
}
